var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _g2, _g3, _path10, _path11, _path12, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _path13, _path14, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _path15, _path16, _path17, _tspan42, _tspan43, _tspan44, _tspan45, _path18, _path19, _tspan46, _tspan47, _path20, _path21, _path22, _path23, _tspan48, _tspan49, _tspan50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1990,
    height: 1080,
    viewBox: "0 0 1990 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1990,
    height: 1080,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 1980,
    height: 1080,
    fill: "#003532"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Y_axis"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M102 324.2H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M102 400.4H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102 476.5H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M102 552.7H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M102 629H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M102 705.1H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M102 781.3H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M102 857.6H111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "y_axis",
    d: "M110.5 308V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "y_axis_texts"
  }, /*#__PURE__*/React.createElement("text", {
    id: 160,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 63.5,
    y: 329.7
  }, "160"))), /*#__PURE__*/React.createElement("text", {
    id: 140,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 63.5,
    y: 405.7
  }, "140"))), /*#__PURE__*/React.createElement("text", {
    id: 120,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 63.5,
    y: 482.7
  }, "120"))), /*#__PURE__*/React.createElement("text", {
    id: 100,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 63.5,
    y: 558.7
  }, "100"))), /*#__PURE__*/React.createElement("text", {
    id: 80,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 73.5,
    y: 634.7
  }, "80"))), /*#__PURE__*/React.createElement("text", {
    id: 60,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 73.5,
    y: 711.7
  }, "60"))), /*#__PURE__*/React.createElement("text", {
    id: 40,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 72.5,
    y: 787.7
  }, "40"))), /*#__PURE__*/React.createElement("text", {
    id: 20,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 73.5,
    y: 862.7
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: 0,
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 70.5,
    y: 939.7
  }, "0"))))), /*#__PURE__*/React.createElement("g", {
    id: "x_axis_texts"
  }, /*#__PURE__*/React.createElement("text", {
    id: "2021-01-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 58.9023,
    y: 966.9
  }, "2021-01-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2021-04-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 194.902,
    y: 966.9
  }, "2021-04-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2021-07-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 334.902,
    y: 966.9
  }, "2021-07-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2021-10-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 473.902,
    y: 966.9
  }, "2021-10-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2022-01-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 613.902,
    y: 966.9
  }, "2022-01-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2022-04-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 750.902,
    y: 966.9
  }, "2022-04-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2022-07-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 888.902,
    y: 966.9
  }, "2022-07-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2022-10-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1029.9,
    y: 966.9
  }, "2022-10-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2023-01-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1168.9,
    y: 966.9
  }, "2023-01-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2023-04-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 1306.9,
    y: 966.9
  }, "2023-04-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2023-07-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1444.9,
    y: 966.9
  }, "2023-07-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2023-10-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584.9,
    y: 966.9
  }, "2023-10-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2024-01-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1724.9,
    y: 966.9
  }, "2024-01-01"))), /*#__PURE__*/React.createElement("text", {
    id: "2024-04-01",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1862.9,
    y: 966.9
  }, "2024-04-01")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "X_axis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M246.5 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M384.898 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M524.898 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M664.898 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M801.898 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M940.398 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1080.4 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1220.4 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1357.4 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1495.8 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1495.8 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M1635.9 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M1776 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M1914.4 934V944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "x_axis",
    d: "M92 934H1922",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line_chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.402 650C113.902 648.5 114.402 647 114.902 647C115.402 647 115.902 650.8 116.402 650.8C117.402 650.8 118.402 648.7 119.402 648.4C120.902 647.9 122.402 647.7 124.002 647.7C125.602 647.7 125.002 648.3 125.502 648.9C126.002 649.5 126.502 651.6 127.002 651.6C127.502 651.6 128.002 651.6 128.502 651.6C129.002 651.6 129.502 652.1 130.002 652.1C131.502 652.1 133.002 650.2 134.602 650.2C136.202 650.2 135.602 651.1 136.102 651.5C136.602 651.9 137.102 652.8 137.602 652.8C138.102 652.8 138.602 652.3 139.102 651.4C139.602 650.5 140.102 646.9 140.602 646.4C142.102 645.2 143.602 644.5 145.202 644.5C146.802 644.5 146.202 644.8 146.702 644.8C147.202 644.8 147.702 644.5 148.202 644C148.702 643.5 149.202 642 149.702 642C150.202 642 150.702 642.5 151.202 642.6C152.702 643 154.202 643.2 155.802 643.2C157.402 643.2 156.802 643.2 157.302 643C157.802 643 158.302 642.8 158.802 642.8C159.302 642.8 159.802 643.2 160.302 643.7C160.802 644.2 161.302 645.1 161.802 645.7C163.302 647.5 164.802 647.7 166.402 649C166.902 649.4 167.402 649.9 167.902 650.3C168.402 650.7 168.902 651.3 169.402 651.4C169.902 651.6 170.402 651.6 170.902 651.6C171.402 651.6 171.902 649.6 172.402 649.6C173.902 649.6 175.402 652.4 177.002 652.4C178.602 652.4 178.002 652 178.502 651.7C179.002 651.4 179.502 650.6 180.002 650.6C180.502 650.6 181.002 650.7 181.502 650.7C182.002 650.7 182.502 650.6 183.002 650.6C183.502 650.6 184.002 650.6 184.502 650.6C185.502 650.6 186.502 647.3 187.502 647.3C188.502 647.3 189.502 650.1 190.502 650.1C191.502 650.1 191.502 648.4 192.002 648.2C192.502 648 193.002 647.8 193.502 647.8C195.002 647.8 196.502 648.9 198.102 648.9C199.702 648.9 199.102 648.6 199.602 648.6C200.102 648.6 200.602 651.1 201.102 651.1C201.602 651.1 202.102 647.7 202.602 647.7C203.102 647.7 203.602 648.3 204.102 648.4C206.102 649 208.202 648.7 210.202 649.3C210.702 649.5 211.202 650.4 211.702 650.8C212.202 651.2 212.702 651.6 213.202 651.8C213.702 652.1 214.202 652.1 214.702 652.3C216.202 652.8 217.702 652.7 219.302 653.4C219.802 653.6 220.302 654.9 220.802 654.9C221.302 654.9 221.802 651.1 222.302 650.6C222.802 650.1 223.302 649.9 223.802 649.8C224.302 649.8 224.802 649.8 225.302 649.7C226.802 649.4 228.302 648.9 229.902 647.2C230.402 646.7 230.902 642.8 231.402 642.2C231.902 641.6 232.402 641.3 232.902 641.3C233.402 641.3 233.902 641.3 234.402 641.5C234.902 641.7 235.402 642.9 235.902 643C237.402 643.2 238.902 643.3 240.502 643.3C242.102 643.3 241.502 643 242.002 643C242.502 643 243.002 644.1 243.502 644.1C244.002 644.1 244.502 642.2 245.002 642C245.502 641.8 246.002 641.8 246.502 641.7C248.002 641.4 249.502 641.4 251.102 640.9C251.602 640.7 252.102 639.4 252.602 638.6C253.102 637.8 253.602 636 254.102 636C254.602 636 255.102 638.5 255.602 638.5C256.102 638.5 256.602 638.3 257.102 638.1C258.602 637.7 260.102 637.1 261.702 637.1C263.302 637.1 262.702 637.3 263.202 637.8C263.702 638.3 264.202 643.8 264.702 643.8C265.202 643.8 265.702 637.9 266.202 637.9C266.702 637.9 267.202 643.4 267.702 643.4C269.202 643.4 270.702 642.9 272.302 641.9C272.802 641.6 273.302 639.6 273.802 639.6C274.302 639.6 274.802 639.6 275.302 639.7C275.802 639.7 276.302 640.1 276.802 641C277.302 641.8 277.802 646.3 278.302 646.4C279.802 646.8 281.302 647 282.902 647C284.502 647 283.902 646.8 284.402 646.8C284.902 646.8 285.402 647.1 285.902 647.4C286.402 647.7 286.902 648.4 287.402 648.4C287.902 648.4 288.402 646.5 288.902 646.5C290.902 646.2 293.002 646.1 295.002 646.1C297.002 646.1 296.002 647.1 296.502 647.5C297.002 647.9 297.502 647.9 298.002 648.3C298.502 648.7 299.002 650.1 299.502 650.1C301.002 650.1 302.502 650 304.102 650C305.702 650 305.102 650.2 305.602 650.2C306.102 650.2 306.602 648.8 307.102 648.8C307.602 648.8 308.102 649 308.602 649.4C309.102 649.8 309.602 651.1 310.102 651.1C311.602 651.1 313.102 650.9 314.702 650.9C316.302 650.9 315.702 651.4 316.202 651.5C316.702 651.6 317.202 651.6 317.702 651.7C318.202 651.8 318.702 651.9 319.202 652.1C319.702 652.2 320.202 652.5 320.702 652.5C322.202 652.5 323.702 651.8 325.302 651.8C326.902 651.8 326.302 652.9 326.802 652.9C327.302 652.9 327.802 652.3 328.302 652.3C328.802 652.3 329.302 652.8 329.802 652.8C330.302 652.8 330.802 652.4 331.302 652.4C332.802 652.4 334.302 653.2 335.902 653.2C337.502 653.2 336.902 652.5 337.402 652.4C337.902 652.4 338.402 652.3 338.902 652.3C339.402 652.3 339.902 653.6 340.402 653.7C340.902 653.7 341.402 653.7 341.902 653.7C343.402 653.8 344.902 654.2 346.502 654.7C347.002 654.9 347.502 654.9 348.002 655.2C348.502 655.6 349.002 657 349.502 657.2C350.002 657.5 350.502 657.6 351.002 657.6C351.502 657.6 352.002 657.6 352.502 657.6C354.002 657.6 355.502 657.2 357.102 657.2C358.702 657.2 358.102 657.2 358.602 657.2C359.102 657.2 359.602 655.9 360.102 655.9C360.602 655.9 361.102 656 361.602 656C362.102 656 362.602 655.4 363.102 655.2C364.602 654.4 366.102 653.4 367.702 653.4C369.302 653.4 368.702 653.4 369.202 653.5C369.702 653.5 370.202 654.6 370.702 655.1C371.202 655.6 371.702 656.1 372.202 656.5C372.702 656.9 373.202 657.4 373.702 657.4C375.202 657.4 376.702 657.4 378.302 657.4C378.802 657.4 379.302 655.8 379.802 655.2C380.302 654.6 380.802 654.3 381.302 653.9C381.802 653.5 382.302 653.1 382.802 652.8C383.302 652.4 383.802 651.8 384.302 651.8C385.802 651.8 387.302 652.5 388.902 652.5C390.502 652.5 389.902 649.8 390.402 648.9C390.902 648.1 391.402 648 391.902 647.5C392.402 647 392.902 645.9 393.402 645.9C393.902 645.9 394.402 648.3 394.902 648.3C396.402 648.3 397.902 648 399.502 648C401.102 648 400.502 649.1 401.002 649.5C401.502 649.8 402.002 650 402.502 650C403.002 650 403.502 649.4 404.002 649.4C404.502 649.4 405.002 649.9 405.502 649.9C407.002 649.9 408.502 648.2 410.102 648.2C411.702 648.2 411.102 648.3 411.602 648.4C412.102 648.5 412.602 648.6 413.102 649C413.602 649.4 414.102 651 414.602 651.3C415.102 651.6 415.602 651.8 416.102 651.8C417.602 651.8 419.102 650.2 420.702 650.2C422.302 650.2 421.702 651.2 422.202 651.4C422.702 651.7 423.202 651.5 423.702 651.8C424.202 652.1 424.702 653.7 425.202 653.7C425.702 653.7 426.202 653.4 426.702 653.4C428.202 653.4 429.702 654.1 431.302 654.2C431.802 654.2 432.302 654.3 432.802 654.3C433.302 654.3 433.802 653.9 434.302 653.9C434.802 653.9 435.302 653.9 435.802 653.9C436.302 653.9 436.802 653.2 437.302 653C438.802 652.5 440.302 652.8 441.902 652.3C442.402 652.1 442.902 651.2 443.402 651C443.902 650.8 444.402 650.6 444.902 650.6C445.402 650.6 445.902 652.2 446.402 652.4C446.902 652.5 447.402 652.5 447.902 652.6C449.402 652.8 450.902 653.1 452.502 653.1C454.102 653.1 453.502 652.8 454.002 652.6C454.502 652.4 455.002 652.1 455.502 651.7C456.002 651.2 456.502 650.3 457.002 649.9C457.502 649.4 458.002 649 458.502 649C460.002 649 461.502 650 463.102 650.5C463.602 650.7 464.102 651 464.602 651C465.102 651 465.602 651 466.102 650.8C466.602 650.7 467.102 649.4 467.602 649.4C468.102 649.4 468.602 650.1 469.102 650.4C470.602 651.3 472.102 651.7 473.702 652.4C474.202 652.6 474.702 652.8 475.202 653.1C475.702 653.3 476.202 653.6 476.702 653.9C477.202 654.2 477.702 654.6 478.202 654.8C478.702 655 479.202 655.3 479.702 655.3C481.202 655.3 482.702 655.1 484.302 654.8C484.802 654.7 485.302 653.9 485.802 653.6C486.302 653.3 486.802 653.1 487.302 653.1C487.802 653.1 488.302 653.8 488.802 654C489.302 654.2 489.802 654.3 490.302 654.3C491.802 654.3 493.302 654.3 494.902 654.3C496.502 654.3 495.902 655.2 496.402 655.2C496.902 655.2 497.402 654.9 497.902 654.9C498.402 654.9 498.902 656.6 499.402 656.6C499.902 656.6 500.402 655.8 500.902 655.4C502.402 654.3 503.902 652.8 505.502 652.8C507.102 652.8 506.502 652.9 507.002 653.2C507.502 653.5 508.002 654.5 508.502 654.7C509.002 654.9 509.502 655 510.002 655C510.502 655 511.002 654.8 511.502 654.8C513.002 654.8 514.502 656.1 516.102 656.1C517.702 656.1 517.102 655 517.602 655C518.102 655 518.602 655.3 519.102 655.3C519.602 655.3 520.102 655.3 520.602 655.3C521.102 655.3 521.602 654.2 522.102 654.2C523.602 654.2 525.102 654.5 526.702 655.1C527.202 655.3 527.702 656.3 528.202 656.3C528.702 656.3 529.202 656.1 529.702 656.1C530.202 656.1 530.702 656.6 531.202 657C531.702 657.4 532.202 658.5 532.702 658.6C534.202 659 535.702 659.2 537.302 659.2C538.902 659.2 538.302 659 538.802 658.8C539.302 658.7 539.802 658.3 540.302 658.3C540.802 658.3 541.302 658.5 541.802 658.8C542.302 659.1 542.802 660.9 543.302 660.9C544.802 661.1 546.302 660.9 547.902 661.2C548.402 661.2 548.902 661.2 549.402 661.5C549.902 661.7 550.402 662.2 550.902 662.2C551.402 662.2 551.902 661.6 552.402 661.6C552.902 661.6 553.402 662 553.902 662.2C555.402 662.8 556.902 663 558.502 664.7C559.002 665.3 559.502 667.4 560.002 667.4C560.502 667.4 561.002 664.2 561.502 664C562.002 663.8 562.502 663.9 563.002 663.7C563.502 663.5 564.002 663.1 564.502 662.8C566.002 661.9 567.502 661.5 569.102 660.3C569.602 659.9 570.102 659.4 570.602 659C571.102 658.6 571.602 658 572.102 658C573.102 658 574.102 658.8 575.102 659.1C576.602 659.7 578.102 660.1 579.702 660.8C580.202 661 580.702 661.5 581.202 661.5C581.702 661.5 582.202 661.5 582.702 661.5C583.202 661.5 583.702 661 584.202 659.9C584.702 658.8 585.202 654.4 585.702 654.4C587.202 654.4 588.702 655.6 590.302 655.6C591.902 655.6 591.302 653.3 591.802 653.3C592.302 653.3 592.802 654.2 593.302 654.2C593.802 654.2 594.302 654.2 594.802 654C595.302 653.9 595.802 653.1 596.302 652.7C597.802 651.2 599.302 648.4 600.902 647.4C601.402 647.1 601.902 646.6 602.402 646.6C602.902 646.6 603.402 647.3 603.902 647.4C604.402 647.5 604.902 647.6 605.402 647.6C605.902 647.6 606.402 644.2 606.902 644.2C608.402 644.2 609.902 644.6 611.502 645.3C612.002 645.5 612.502 646.4 613.002 647.2C613.502 648 614.002 649.7 614.502 650C615.002 650.3 615.502 650.2 616.002 650.5C616.502 650.8 617.002 651.5 617.502 651.5C619.002 651.5 620.502 650.1 622.102 649.7C622.602 649.6 623.102 649.4 623.602 649.4C624.102 649.4 624.602 650.7 625.102 651.2C625.602 651.7 626.102 652.3 626.602 652.3C627.102 652.3 627.602 652.2 628.102 652.2C629.602 652.2 631.102 652.5 632.702 652.5C634.302 652.5 633.702 652.1 634.202 651.7C634.702 651.3 635.202 650 635.702 650C636.202 650 636.702 651.9 637.202 651.9C637.702 651.9 638.202 650.6 638.702 650.4C640.202 649.8 641.702 649.5 643.302 649.5C644.902 649.5 644.302 650.7 644.802 650.7C645.302 650.7 645.802 650.7 646.302 650.7C646.802 650.7 647.302 652.1 647.802 652.2C648.302 652.3 648.802 652.3 649.302 652.4C650.802 652.5 652.302 652.6 653.902 652.6C655.502 652.6 654.902 652.1 655.402 651.8C655.902 651.5 656.402 651.4 656.902 650.6C657.402 649.8 657.902 647.1 658.402 647C660.402 646.9 662.502 647 664.502 646.8C665.002 646.8 665.502 646.3 666.002 645.3C666.502 644.3 667.002 641.5 667.502 640.3C668.002 639.2 668.502 638.6 669.002 638.6C669.502 638.6 670.002 641.1 670.502 641.7C672.002 643.6 673.502 642.6 675.102 644.5C675.602 645.1 676.102 647.1 676.602 647.4C677.102 647.7 677.602 647.9 678.102 647.9C678.602 647.9 679.102 642.6 679.602 641.6C680.102 640.6 680.602 640.1 681.102 640.1C682.602 640.1 684.102 640.8 685.702 640.8C687.302 640.8 686.702 640.2 687.202 640C687.702 639.8 688.202 639.4 688.702 639.4C689.202 639.4 689.702 640.9 690.202 640.9C690.702 640.9 691.202 638.9 691.702 638C693.202 635.2 694.702 630.6 696.302 630.6C697.902 630.6 697.302 631.2 697.802 631.2C698.302 631.2 698.802 627.3 699.302 627.3C699.802 627.3 700.302 628.3 700.802 629.6C701.302 630.9 701.802 634.7 702.302 635.1C703.802 636.3 705.302 635.7 706.902 636.8C707.402 637.2 707.902 637.9 708.402 638.5C708.902 639.1 709.402 640.2 709.902 640.4C710.402 640.6 710.902 640.4 711.402 640.7C711.902 640.9 712.402 641.5 712.902 641.8C714.402 642.8 715.902 642.4 717.502 643.5C718.002 643.9 718.502 644.8 719.002 645.4C719.502 646 720.002 647.2 720.502 647.2C721.002 647.2 721.502 647.3 722.002 647.3C722.502 647.3 723.002 638 723.502 637.6C725.002 636.4 726.502 635.8 728.102 635.8C729.702 635.8 729.102 639 729.602 640.7C730.102 642.4 730.602 646.1 731.102 646.1C731.602 646.1 732.102 642.7 732.602 641.3C733.102 640 733.602 639.1 734.102 638C735.602 634.6 737.102 629.7 738.702 627.1C739.202 626.2 739.702 625.8 740.202 624.8C740.702 623.8 741.202 623.6 741.702 621.3C742.202 619 742.702 604.4 743.202 589.6C743.702 574.7 744.202 540.7 744.702 532.1C746.202 506.3 747.702 505.5 749.302 493.4C749.802 489.4 750.302 481.6 750.802 481.6C751.302 481.6 751.802 492.9 752.302 492.9C752.802 492.9 753.302 488.9 753.802 480.9C754.302 473 754.802 457.4 755.302 445.4C756.802 409.1 758.302 330 759.902 330C761.502 330 760.902 370.2 761.402 394C761.902 417.8 762.402 472.8 762.902 472.8C763.402 472.8 763.902 471.4 764.402 471.4C764.902 471.4 765.402 479.2 765.902 481.7C767.402 489.1 768.902 487.6 770.502 492.8C771.002 494.5 771.502 495 772.002 498.5C772.502 502 773.002 509.9 773.502 513.8C774.002 517.7 774.502 518.9 775.002 521.8C775.502 524.7 776.002 531 776.502 531C778.002 531 779.502 530.8 781.102 530.8C782.702 530.8 782.102 535.8 782.602 535.8C783.102 535.8 783.602 535.2 784.102 535.2C784.602 535.2 785.102 560.3 785.602 561C786.102 561.7 786.602 561.6 787.102 562C788.602 563.2 790.102 563.9 791.702 567.6C792.202 568.8 792.702 584.6 793.202 591.4C793.702 598.2 794.202 606.8 794.702 608.5C795.202 610.3 795.702 610.6 796.202 611.2C796.702 611.8 797.202 612.2 797.702 612.2C799.202 612.2 800.702 609.6 802.302 609.6C803.902 609.6 803.302 612.5 803.802 613.4C804.302 614.3 804.802 613.9 805.302 614.8C805.802 615.7 806.302 625.1 806.802 629.8C807.302 634.5 807.802 643 808.302 643C809.802 643 811.302 623.8 812.902 623.8C814.502 623.8 813.902 627.8 814.402 627.8C814.902 627.8 815.402 627.8 815.902 627.6C816.402 627.5 816.902 619.6 817.402 619.6C817.902 619.6 818.402 624.8 818.902 625.3C820.402 626.7 821.902 626 823.502 627.4C824.002 627.9 824.502 628.5 825.002 629.7C825.502 630.9 826.002 632.3 826.502 634.3C827.002 636.3 827.502 639.9 828.002 641.6C828.502 643.3 829.002 644.1 829.502 644.5C831.002 645.5 832.502 645 834.102 646.1C834.602 646.4 835.102 653.4 835.602 653.4H837.102C837.602 653.4 838.102 655.5 838.602 656.2C839.102 657 839.602 657.3 840.102 657.9C842.102 660 844.202 663.2 846.202 663.2H847.702C848.202 663.2 848.702 675.8 849.202 675.8C849.702 675.8 850.202 666.2 850.702 666.2C852.202 666.2 853.702 669.2 855.302 669.2C856.902 669.2 857.302 666.2 858.302 666.2C859.302 666.2 859.302 673.8 859.802 676.9C860.302 679.9 860.802 683.8 861.302 684.5C862.802 686.7 864.302 685.9 865.902 687.8C866.402 688.4 866.902 690 867.402 690C867.902 690 868.402 689.8 868.902 689.8C869.402 689.8 869.902 690.3 870.402 691.4C870.902 692.5 871.402 696.5 871.902 697.9C873.402 702 874.902 700 876.502 704.1C877.002 705.5 877.502 713.3 878.002 713.3C878.502 713.3 879.002 710.1 879.502 705.2C880.002 700.3 880.502 688.4 881.002 683.8C881.502 679.2 882.002 676.9 882.502 676.9C884.002 676.9 885.502 677.8 887.102 679.7C887.602 680.3 888.102 689.8 888.602 692.7C889.102 695.6 889.602 696.8 890.102 697.3C890.602 697.8 891.102 698 891.602 698C892.102 698 892.602 695.8 893.102 695.8C894.602 695.8 896.102 696.9 897.702 698.2C898.202 698.6 898.702 699.1 899.202 699.6C899.702 700.1 900.202 700.1 900.702 701.2C901.202 702.3 901.702 705.7 902.202 706.3C902.702 706.9 903.202 706.9 903.702 707.2C905.702 708.4 907.802 708.8 909.802 711.9C910.302 712.7 910.802 716.1 911.302 716.1C911.802 716.1 912.302 715.9 912.802 715.9C913.302 715.9 913.802 716.4 914.302 716.6C915.802 717.1 917.302 716.9 918.902 717.4C919.402 717.6 919.902 719.3 920.402 721.2C920.902 723.1 921.402 728.9 921.902 728.9C922.402 728.9 922.902 728.7 923.402 728.7C923.902 728.7 924.402 729.1 924.902 729.1C926.402 729.1 927.902 726.6 929.502 726.6C931.102 726.6 930.502 730.1 931.002 730.4C931.502 730.6 932.002 730.7 932.502 730.7C933.002 730.7 933.502 730.5 934.002 730.2C934.502 729.9 935.002 721.7 935.502 721.2C937.002 719.6 938.502 720.4 940.102 718.7C940.602 718.1 941.102 701.8 941.602 696.6C942.102 691.4 942.602 687.7 943.102 687.7C943.602 687.7 944.102 688 944.602 688.7C945.102 689.3 945.602 697.7 946.102 697.8C947.602 698.2 949.102 698 950.702 698.4C951.202 698.5 951.702 706.4 952.202 707.3C952.702 708.2 953.202 708.1 953.702 708.7C954.202 709.3 954.702 710.7 955.202 710.7C955.702 710.7 956.202 709.5 956.702 709.5C958.202 709.5 959.702 713.3 961.302 716.1C961.802 717 962.302 718 962.802 719.1C963.302 720.2 963.802 722.7 964.302 722.7C964.802 722.7 965.302 710.1 965.802 710.1C966.302 710.1 966.802 710.5 967.302 710.7C968.802 711.3 970.302 712.3 971.902 712.3C973.502 712.3 972.902 701.5 973.402 701.5C973.902 701.5 974.402 701.5 974.902 701.5C975.402 701.5 975.902 701.2 976.402 700.7C976.902 700.2 977.402 697.2 977.902 696.9C979.402 695.9 980.902 695.4 982.502 695.4C984.102 695.4 983.502 703.7 984.002 703.7C984.502 703.7 985.002 703.1 985.502 702.9C986.002 702.7 986.502 702.3 987.002 702.3C987.502 702.3 988.002 703.2 988.502 703.2C990.002 703.2 991.502 702.1 993.102 702.1C994.702 702.1 994.102 702.5 994.602 702.6C995.102 702.7 995.602 702.9 996.102 702.9C996.602 702.9 997.102 702.8 997.602 702.5C998.102 702.3 998.602 701.8 999.102 701.5C1000.6 700.5 1002.1 699.1 1003.7 699.1C1005.3 699.1 1004.7 699.1 1005.2 699.3C1005.7 699.4 1006.2 700.4 1006.7 701C1007.2 701.5 1007.7 701.5 1008.2 702.5C1008.7 703.5 1009.2 707.2 1009.7 707.2C1011.2 707.2 1012.7 706.1 1014.3 705.1C1014.8 704.8 1015.3 704 1015.8 704C1016.3 704 1016.8 704.9 1017.3 704.9C1017.8 704.9 1018.3 704.8 1018.8 704.6C1019.3 704.4 1019.8 703.7 1020.3 703.6C1021.8 703.3 1023.3 703.1 1024.9 703.1C1026.5 703.1 1025.9 703.3 1026.4 703.3C1026.9 703.3 1027.4 703.1 1027.9 703.1C1028.4 703.1 1028.9 703.8 1029.4 703.8C1029.9 703.8 1030.4 702.7 1030.9 702.2C1032.4 700.9 1033.9 700.1 1035.5 700.1C1037.1 700.1 1036.5 700.7 1037 700.7C1037.5 700.7 1038 699.6 1038.5 699.6C1039 699.6 1039.5 700.7 1040 701.2C1040.5 701.7 1041 702.6 1041.5 702.6C1043 702.6 1044.5 702.6 1046.1 702.6C1047.7 702.6 1047.1 703.1 1047.6 703.5C1048.1 703.9 1048.6 705.1 1049.1 705.1C1049.6 705.1 1050.1 704.7 1050.6 704.6C1051.1 704.5 1051.6 704.5 1052.1 704.4C1053.6 704.2 1055.1 703.3 1056.7 703.2C1057.2 703.2 1057.7 703.2 1058.2 703.2C1058.7 703.2 1059.2 695.7 1059.7 695.7C1060.2 695.7 1060.7 699.6 1061.2 701.1C1061.7 702.6 1062.2 703.9 1062.7 704.9C1064.2 708 1065.7 709.6 1067.3 709.6C1068.9 709.6 1068.3 709.6 1068.8 709.6C1069.3 709.6 1069.8 709.6 1070.3 709.8C1070.8 709.9 1071.3 712.7 1071.8 712.7C1072.3 712.7 1072.8 711.5 1073.3 711C1074.8 709.4 1076.3 707.1 1077.9 707.1C1079.5 707.1 1078.9 708 1079.4 708C1079.9 708 1080.4 705.2 1080.9 704.3C1081.4 703.3 1081.9 702.9 1082.4 702.1C1082.9 701.3 1083.4 700.2 1083.9 699.4C1085.4 697 1086.9 697.7 1088.5 694.4C1089 693.3 1089.5 689.8 1090 688.7C1090.5 687.6 1091 687 1091.5 687C1092 687 1092.5 688.1 1093 688.9C1093.5 689.7 1094 690.8 1094.5 691.6C1096 694 1097.5 694.8 1099.1 696C1099.6 696.4 1100.1 696.6 1100.6 697C1101.1 697.4 1101.6 698.6 1102.1 698.6C1102.6 698.6 1103.1 698 1103.6 698C1104.1 698 1104.6 699.2 1105.1 699.3C1106.6 699.6 1108.1 699.7 1109.7 699.7C1111.3 699.7 1110.7 699.7 1111.2 699.7C1111.7 699.7 1112.2 698.4 1112.7 698.4C1113.2 698.4 1113.7 698.6 1114.2 698.7C1114.7 698.7 1115.2 698.8 1115.7 698.8C1117.2 698.8 1118.7 698.6 1120.3 698.6C1121.9 698.6 1121.3 698.7 1121.8 698.8C1122.3 698.9 1122.8 698.8 1123.3 698.8C1123.8 698.8 1124.3 696.7 1124.8 696.7C1126.8 696.7 1128.9 697 1130.9 697.6C1131.4 697.8 1131.9 700.9 1132.4 700.9C1132.9 700.9 1133.4 700.7 1133.9 700.3C1134.4 699.9 1134.9 698.7 1135.4 698.7C1135.9 698.7 1136.4 702.3 1136.9 702.4C1138.4 702.8 1139.9 703 1141.5 703C1143.1 703 1142.5 703 1143 703C1143.5 703 1144 703 1144.5 703C1145 703 1145.5 703.5 1146 703.5C1146.5 703.5 1147 703 1147.5 702.8C1149 702.2 1150.5 702.1 1152.1 701.9C1152.6 701.9 1153.1 701.7 1153.6 701.7C1154.1 701.7 1154.6 702.5 1155.1 702.5C1155.6 702.5 1156.1 702.5 1156.6 702.5C1157.1 702.5 1157.6 702.8 1158.1 702.8C1159.6 702.8 1161.2 701.3 1162.7 700.8C1163.2 700.6 1163.7 700.3 1164.2 700.3C1164.7 700.3 1165.2 701.5 1165.7 701.5C1166.2 701.5 1166.7 700.5 1167.2 699.8C1167.7 699.2 1168.2 698.1 1168.7 697.7C1170.2 696.4 1171.7 697.1 1173.3 695.8C1173.8 695.4 1174.3 693.1 1174.8 693C1175.3 692.9 1175.8 692.8 1176.3 692.8C1176.8 692.8 1177.3 693.6 1177.8 693.9C1178.3 694.2 1178.8 694.6 1179.3 694.6C1180.8 694.6 1182.3 694.4 1183.9 693.9C1184.4 693.7 1184.9 693.6 1185.4 692.9C1185.9 692.2 1186.4 690.7 1186.9 689.7C1187.4 688.7 1187.9 686.7 1188.4 686.7C1188.9 686.7 1189.4 687.3 1189.9 687.3C1191.4 687.3 1193 678 1194.5 673.8C1195 672.4 1195.5 671.4 1196 669.7C1196.5 668 1197 665.6 1197.5 663.7C1198 661.7 1198.5 658 1199 658C1199.5 658 1200 666.4 1200.5 666.4C1202 666.4 1203.5 666.4 1205.1 666.4C1205.6 666.4 1206.1 663.5 1206.6 662.3C1207.1 661.1 1207.6 660 1208.1 659.1C1208.6 658.2 1209.1 656.7 1209.6 656.7C1210.1 656.7 1210.6 657.5 1211.1 657.9C1213.1 659.4 1215.2 662 1217.2 662C1219.2 662 1218.2 659.8 1218.7 659.5C1219.2 659.2 1219.7 659.3 1220.2 659.1C1220.7 658.9 1221.2 658.3 1221.7 658.3C1223.2 658.3 1224.7 658.6 1226.3 659.1C1226.8 659.3 1227.3 667.3 1227.8 667.3C1228.3 667.3 1228.8 666.2 1229.3 666.2C1229.8 666.2 1230.3 671.4 1230.8 671.6C1231.3 671.8 1231.8 671.9 1232.3 671.9C1233.8 671.9 1235.3 671.6 1236.9 671C1237.4 670.8 1237.9 670.5 1238.4 670.1C1238.9 669.7 1239.4 668.6 1239.9 668.6C1240.4 668.6 1240.9 670.6 1241.4 671C1241.9 671.4 1242.4 671.7 1242.9 671.7C1244.4 671.7 1245.9 671.7 1247.5 671.7C1249.1 671.7 1248.5 671.1 1249 670.9C1249.5 670.7 1250 670.7 1250.5 670.3C1251 670 1251.5 668.8 1252 668.8C1252.5 668.8 1253 669.5 1253.5 669.5C1255 669.5 1256.6 667.6 1258.1 666.1C1258.6 665.6 1259.1 664.6 1259.6 664.6C1260.1 664.6 1260.6 666.1 1261.1 666.1C1261.6 666.1 1262.1 666.1 1262.6 665.8C1263.1 665.6 1263.6 664.9 1264.1 664.6C1265.6 663.8 1267.1 663.7 1268.7 663.3C1269.2 663.2 1269.7 663.2 1270.2 662.9C1270.7 662.6 1271.2 660 1271.7 658.6C1272.2 657.2 1272.7 654.7 1273.2 654.7C1273.7 654.7 1274.2 654.7 1274.7 654.7C1276.2 654.7 1277.7 653.4 1279.3 652.9C1279.8 652.7 1280.3 652.8 1280.8 652.5C1281.3 652.2 1281.8 650.6 1282.3 650C1282.8 649.4 1283.3 649.4 1283.8 649.1C1284.3 648.7 1284.8 647.7 1285.3 647.7C1286.8 647.7 1288.4 649.2 1289.9 649.2C1291.4 649.2 1290.9 648.4 1291.4 648.2C1291.9 648 1292.4 648.1 1292.9 647.9C1293.9 647.5 1294.9 643.8 1296 643.6C1297.5 643.3 1299 643.2 1300.6 643.2C1302.2 643.2 1301.6 647.7 1302.1 647.7C1302.6 647.7 1303.1 647.3 1303.6 647.1C1304.1 646.8 1304.6 646.4 1305.1 646.2C1305.6 646 1306.1 645.9 1306.6 645.8C1308.1 645.5 1309.6 645.6 1311.2 645.3C1311.7 645.2 1312.2 644.5 1312.7 644.4C1313.7 644.2 1314.7 644.2 1315.7 644.2C1316.7 644.2 1316.7 644.4 1317.2 644.4C1318.7 644.4 1320.2 644.4 1321.8 644.4C1322.3 644.4 1322.8 646.7 1323.3 646.7C1323.8 646.7 1324.3 645.1 1324.8 644C1325.3 642.9 1325.8 639.8 1326.3 639.8C1326.8 639.8 1327.3 640.4 1327.8 640.4C1329.3 640.4 1330.8 638.1 1332.4 638.1C1334 638.1 1333.4 639.4 1333.9 639.8C1334.4 640.2 1334.9 640.5 1335.4 640.6C1335.9 640.6 1336.4 640.7 1336.9 640.7C1337.4 640.7 1337.9 640.5 1338.4 640.5C1339.9 640.3 1341.4 640.1 1343 640.1C1344.6 640.1 1344 640.8 1344.5 640.8C1345 640.8 1345.5 640.3 1346 640.1C1346.5 639.9 1347 640 1347.5 639.7C1348 639.4 1348.5 638.1 1349 637.4C1350.5 635.4 1352.1 636.2 1353.6 633.9C1354.1 633.1 1354.6 631.7 1355.1 631.1C1355.6 630.4 1356.1 630.7 1356.6 630C1357.1 629.3 1357.6 626.4 1358.1 624.1C1358.6 621.8 1359.1 616.3 1359.6 616.3C1361.1 616.3 1362.6 621.4 1364.2 621.4C1365.8 621.4 1365.2 619.7 1365.7 619.7C1366.2 619.7 1366.7 619.9 1367.2 620.2C1367.7 620.5 1368.2 621.1 1368.7 621.4C1369.2 621.7 1369.7 622 1370.2 622C1371.7 622 1373.2 620.9 1374.8 620.9C1376.4 620.9 1375.8 621.9 1376.3 622C1376.8 622 1377.3 622 1377.8 622C1378.3 622 1378.8 622 1379.3 622C1379.8 622 1380.3 622.4 1380.8 622.4C1382.3 622.4 1383.9 622.2 1385.4 622.2C1386.9 622.2 1386.4 622.8 1386.9 622.8C1387.4 622.8 1387.9 622.8 1388.4 622.6C1388.9 622.4 1389.4 621.7 1389.9 621.7C1390.4 621.7 1390.9 622.6 1391.4 623.1C1393.4 624.8 1395.5 624.4 1397.5 627.1C1398 627.8 1398.5 628.6 1399 629.3C1399.5 630 1400 630.3 1400.5 631.5C1401 632.6 1401.5 636.1 1402 636.1C1403.5 636.1 1405 635.1 1406.6 635.1C1408.2 635.1 1408.6 635.5 1409.7 636.2C1410.8 636.9 1410.7 640 1411.2 640C1411.7 640 1412.2 637.9 1412.7 637C1414.2 634.3 1415.7 634.6 1417.3 631.2C1417.8 630.1 1418.3 628.3 1418.8 627.3C1419.3 626.3 1419.8 625.3 1420.3 625.3C1420.8 625.3 1421.3 627.5 1421.8 627.5C1422.3 627.5 1422.8 627.1 1423.3 627.1C1424.8 627.1 1426.3 628.7 1427.9 628.7C1429.5 628.7 1428.9 627.5 1429.4 627.5C1429.9 627.5 1430.4 628 1430.9 628C1431.4 628 1431.9 628 1432.4 628C1432.9 628 1433.4 628.3 1433.9 628.3C1435.4 628.3 1436.9 627.4 1438.5 625.9C1439 625.4 1439.5 624.1 1440 624.1C1440.5 624.1 1441 624.3 1441.5 624.4C1442 624.5 1442.5 624.8 1443 624.8C1443.5 624.8 1444 623.8 1444.5 623.5C1446 622.5 1447.5 622 1449.1 622C1450.7 622 1450.1 623 1450.6 623C1451.1 623 1451.6 622.4 1452.1 621.7C1452.6 621 1453.1 619.5 1453.6 618.8C1454.1 618.1 1454.6 618.1 1455.1 617.7C1457.1 616.2 1459.2 616 1461.2 612.8C1461.7 612 1462.2 610.1 1462.7 610.1C1463.2 610.1 1463.7 610.7 1464.2 611.2C1464.7 611.7 1465.2 613 1465.7 613C1467.2 613 1468.7 612.5 1470.3 611.8C1470.8 611.5 1471.3 611.2 1471.8 610.9C1472.3 610.7 1472.8 610.3 1473.3 610.3C1473.8 610.3 1474.3 613.5 1474.8 613.5C1475.3 613.5 1475.8 611.6 1476.3 610.7C1477.8 608 1479.3 603.4 1480.9 603.4C1482.5 603.4 1481.9 609.1 1482.4 609.1C1482.9 609.1 1483.4 605.8 1483.9 604.3C1484.4 602.8 1484.9 602.3 1485.4 600.3C1485.9 598.3 1486.4 592.2 1486.9 592.2C1488.4 592.2 1490 592.2 1491.5 592.2C1493 592.2 1492.5 591.3 1493 590.4C1493.5 589.5 1494 588.8 1494.5 586.5C1495 584.2 1495.5 576.7 1496 576.7C1496.5 576.7 1497 581.9 1497.5 582.2C1499 583 1500.5 582.6 1502.1 583.5C1502.6 583.8 1503.1 586.8 1503.6 587.1C1504.1 587.4 1504.6 587.5 1505.1 587.5C1505.6 587.5 1506.1 586 1506.6 586C1507.1 586 1507.6 589.4 1508.1 589.4C1509.6 589.4 1511.1 587.2 1512.7 586.8C1513.2 586.7 1513.7 586.8 1514.2 586.6C1514.7 586.5 1515.2 585.5 1515.7 585.5C1516.2 585.5 1516.7 585.5 1517.2 585.5C1517.7 585.5 1518.2 587 1518.7 587C1520.2 587 1521.8 586.6 1523.3 586.6C1524.8 586.6 1524.3 588.9 1524.8 588.9C1525.3 588.9 1525.8 588.9 1526.3 588.9C1526.8 588.9 1527.3 588.6 1527.8 588.1C1528.3 587.6 1528.8 584.5 1529.3 583.8C1530.8 581.8 1532.3 580.8 1533.9 580.8C1535.5 580.8 1534.9 581.2 1535.4 581.2C1535.9 581.2 1536.4 576 1536.9 574.4C1537.4 572.8 1537.9 572.9 1538.4 571.6C1538.9 570.3 1539.4 567.5 1539.9 566.9C1541.4 564.9 1542.9 565.2 1544.5 563.9C1545 563.5 1545.5 563.1 1546 562.4C1546.5 561.7 1547 559.9 1547.5 559.9C1548 559.9 1548.5 560.7 1549 560.7C1549.5 560.7 1550 556.4 1550.5 554.7C1552 549.4 1553.5 545.9 1555.1 545.9C1556.7 545.9 1556.1 552.9 1556.6 555.6C1557.1 558.3 1557.6 559.7 1558.1 562C1558.6 564.4 1559.1 567.7 1559.6 569.9C1560.1 572.1 1560.6 575.5 1561.1 575.5C1562.6 575.5 1564.1 572.8 1565.7 572.8C1567.3 572.8 1566.7 573.3 1567.2 573.3C1567.7 573.3 1568.2 571.7 1568.7 571.7C1569.2 571.7 1569.7 572.1 1570.2 572.1C1570.7 572.1 1571.2 569.9 1571.7 569.6C1573.2 568.8 1574.7 569.2 1576.3 568.4C1576.8 568.1 1577.3 566.9 1577.8 566.9C1578.3 566.9 1578.8 567 1579.3 567C1579.8 567 1580.3 565.5 1580.8 565.4C1581.3 565.3 1581.8 565.3 1582.3 565.2C1583.8 565 1585.4 564.9 1586.9 564.3C1587.4 564.1 1587.9 561.6 1588.4 560.6C1588.9 559.6 1589.4 558.8 1589.9 558.5C1590.4 558.2 1590.9 558.2 1591.4 558.1C1591.9 558.1 1592.4 558 1592.9 558C1594.4 558 1595.9 559 1597.5 561C1598 561.7 1598.5 570.9 1599 570.9C1599.5 570.9 1600 567 1600.5 565.7C1601 564.3 1601.5 562.7 1602 562.7C1602.5 562.7 1603 562.7 1603.5 562.7C1605 562.7 1606.5 562.9 1608.1 563.4C1608.6 563.5 1609.1 563.9 1609.6 564C1610.1 564.2 1610.6 564 1611.1 564.3C1611.6 564.5 1612.1 565 1612.6 565.4C1613.1 565.8 1613.6 566.8 1614.1 566.8C1615.6 566.8 1617.2 565.8 1618.7 565.8C1620.2 565.8 1619.7 566.4 1620.2 566.4C1620.7 566.4 1621.2 565 1621.7 564.4C1622.2 563.8 1622.7 563.7 1623.2 563C1623.7 562.3 1624.2 561.1 1624.7 560.1C1626.2 557.4 1627.7 553.8 1629.3 552.8C1629.8 552.5 1630.3 552.3 1630.8 552.3C1631.3 552.3 1631.8 553.1 1632.3 553.1C1632.8 553.1 1633.3 551.5 1633.8 550.4C1634.3 549.4 1634.8 547.5 1635.3 546.9C1636.8 544.9 1638.3 543.9 1639.9 543.9C1641.5 543.9 1640.9 549.3 1641.4 549.5C1641.9 549.8 1642.4 549.6 1642.9 549.9C1643.4 550.2 1643.9 550.5 1644.4 551.8C1644.9 553.1 1645.4 560.1 1645.9 560.3C1647.4 561 1648.9 561.4 1650.5 561.4C1652.1 561.4 1651.5 560.5 1652 560.5C1652.5 560.5 1653 561.1 1653.5 561.4C1654 561.7 1654.5 561.7 1655 562.1C1655.5 562.5 1656 563.2 1656.5 563.8C1658 565.5 1659.5 565.9 1661.1 569.5C1661.6 570.7 1662.1 572.4 1662.6 573.8C1663.1 575.2 1663.6 577.8 1664.1 577.8C1664.6 577.8 1665.1 574.6 1665.6 574.4C1666.1 574.1 1666.6 574 1667.1 574C1668.6 574 1670.1 574.1 1671.7 574.4C1672.2 574.4 1672.7 577.1 1673.2 577.1C1673.7 577.1 1674.2 576.6 1674.7 576.6C1675.2 576.6 1675.7 578.1 1676.2 578.1C1676.7 578.1 1677.2 576.9 1677.7 576.9C1679.2 576.9 1680.8 580.8 1682.3 580.8C1683.8 580.8 1683.3 579.6 1683.8 579.6C1684.3 579.6 1684.8 580.9 1685.3 581.4C1685.8 581.9 1686.3 582.5 1686.8 582.5C1687.3 582.5 1687.8 582.1 1688.3 582C1689.8 581.6 1691.3 581.4 1692.9 581.4C1694.5 581.4 1693.9 582.4 1694.4 583.6C1694.9 584.8 1695.4 587.1 1695.9 588.6C1696.4 590.1 1696.9 592.5 1697.4 592.5C1697.9 592.5 1698.4 589.4 1698.9 589.4C1700.4 589.4 1701.9 589.9 1703.5 590.9C1704 591.2 1704.5 597 1705 597C1705.5 597 1706 596.3 1706.5 596.3C1707 596.3 1707.5 596.6 1708 596.6C1708.5 596.6 1709 593.5 1709.5 593.5C1711 593.5 1712.6 594.5 1714.1 594.5C1715.6 594.5 1715.1 593 1715.6 593H1717.1C1717.6 593 1718.1 592.8 1718.6 592.5C1719.1 592.1 1719.6 589.8 1720.1 589.2C1721.6 587.4 1723.2 588.3 1724.7 586.5C1725.2 585.9 1725.7 582.5 1726.2 581.1C1726.7 579.7 1727.2 578.7 1727.7 578.2C1728.2 577.7 1728.7 577.4 1729.2 577.4C1729.7 577.4 1730.2 581.4 1730.7 581.6C1732.2 582.1 1733.7 581.8 1735.3 582.3C1735.8 582.5 1736.3 587 1736.8 588.2C1737.3 589.4 1737.8 590.1 1738.3 590.1C1738.8 590.1 1739.3 590.1 1739.8 590.1C1740.3 590.1 1740.8 589 1741.3 588.9C1742.8 588.5 1744.3 588.2 1745.9 588.2C1747.5 588.2 1746.9 588.9 1747.4 588.9C1747.9 588.9 1748.4 588.3 1748.9 587.2C1749.4 586.1 1749.9 581.1 1750.4 581.1C1750.9 581.1 1751.4 581.4 1751.9 581.6C1753.4 582.1 1755 581.9 1756.5 582.6C1757 582.8 1757.5 583.5 1758 583.5C1758.5 583.5 1759 583.3 1759.5 583.3C1760 583.3 1760.5 585.1 1761 586C1761.5 586.9 1762 588.7 1762.5 588.7C1765 588.7 1767.6 585.9 1770.1 583.2C1770.6 582.7 1771.1 581.5 1771.6 581.5C1772.1 581.5 1772.6 582.9 1773.1 584.3",
    stroke: "white",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "milestones"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stones"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M525.7 669C532.162 669 537.4 663.583 537.4 656.9C537.4 650.217 532.162 644.8 525.7 644.8C519.238 644.8 514 650.217 514 656.9C514 663.583 519.238 669 525.7 669Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M221.302 661C227.763 661 233.002 655.583 233.002 648.9C233.002 642.217 227.763 636.8 221.302 636.8C214.84 636.8 209.602 642.217 209.602 648.9C209.602 655.583 214.84 661 221.302 661Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M526 653V590",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Faced significant depreciation and volatility",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 300.402,
    y: 523.8
  }, "Faced significant depreciation and volatility"))), /*#__PURE__*/React.createElement("text", {
    id: "due to economic sanctions, fluctuating oil",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 300.402,
    y: 548.8
  }, "due to economic sanctions, fluctuating oil"))), /*#__PURE__*/React.createElement("text", {
    id: "prices and ongoing geopolitical tensions.",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 300.402,
    y: 573.8
  }, "prices and ongoing geopolitical tensions.")))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 743.602,
    y: 318.7
  }, "158.3"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.6016,
    y: 285.7
  }, " Value of the ruble compared to the USD"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1879.6,
    y: 1016.7
  }, "Date"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_5",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 202.5,
    y: 682.6
  }, "76.52"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_6",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 489.5,
    y: 695.6
  }, "72.74"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_7",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 727.5,
    y: 672.6
  }, "75.04"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_8",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 952.5,
    y: 764.6
  }, "53.45"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_9",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584.5,
    y: 539.6
  }, "99.43"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_10",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1462.5,
    y: 650.6
  }, "82.74"))), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_11",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1714.5,
    y: 548.6
  }, "91.71")))), /*#__PURE__*/React.createElement("g", {
    id: "stones_copy"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M711.102 647C717.564 647 722.802 641.583 722.802 634.9C722.802 628.217 717.564 622.8 711.102 622.8C704.641 622.8 699.402 628.217 699.402 634.9C699.402 641.583 704.641 647 711.102 647Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M711 700.5V640.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_12"
  }, /*#__PURE__*/React.createElement("text", {
    id: "The ruble fell following the invasion",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.602,
    y: 719.7
  }, "The ruble fell following the invasion"))), /*#__PURE__*/React.createElement("text", {
    id: "of Ukraian by Western nations, but",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.602,
    y: 744.7
  }, "of Ukraian by Western nations, but"))), /*#__PURE__*/React.createElement("text", {
    id: "capital controls implemented by the",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.602,
    y: 769.7
  }, "capital controls implemented by the"))), /*#__PURE__*/React.createElement("text", {
    id: "textSpecial",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.602,
    y: 794.7
  }, "state bank kept the currency&#x2019;s value"))), /*#__PURE__*/React.createElement("text", {
    id: "back.",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 551.602,
    y: 819.7
  }, "back."))))), /*#__PURE__*/React.createElement("g", {
    id: "stones_copy_2"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M753.302 488.1C758.106 488.1 762.002 484.071 762.002 479.1C762.002 474.129 758.106 470.1 753.302 470.1C748.497 470.1 744.602 474.129 744.602 479.1C744.602 484.071 748.497 488.1 753.302 488.1Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M763.302 340.1C768.106 340.1 772.002 336.071 772.002 331.1C772.002 326.129 768.106 322.1 763.302 322.1C758.497 322.1 754.602 326.129 754.602 331.1C754.602 336.071 758.497 340.1 763.302 340.1Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M763 479H826",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_13"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Russia invades Ukraine which caused a panic and the Ruble plummeted",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 836.602,
    y: 465.7
  }, "Russia invades Ukraine which caused a panic and the Ruble plummeted"))), /*#__PURE__*/React.createElement("text", {
    id: "due to the uncertainty and potential for harsh sanctions. Being excluded",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 836.602,
    y: 490.7
  }, "due to the uncertainty and potential for harsh sanctions. Being excluded"))), /*#__PURE__*/React.createElement("text", {
    id: "from SWIFT makes international payments more difficult and expensive",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 836.602,
    y: 515.7
  }, "from SWIFT makes international payments more difficult and expensive"))), /*#__PURE__*/React.createElement("text", {
    id: "for Russian businesses, hindering trade and weakening the Ruble.",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 836.602,
    y: 540.7
  }, "for Russian businesses, hindering trade and weakening the Ruble."))))), /*#__PURE__*/React.createElement("g", {
    id: "stones_copy_3"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M931.102 742C937.564 742 942.802 736.583 942.802 729.9C942.802 723.217 937.564 717.8 931.102 717.8C924.641 717.8 919.402 723.217 919.402 729.9C919.402 736.583 924.641 742 931.102 742Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M931 850V739",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_14"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Reported strongest Russian rubles since 2015",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 690.602,
    y: 869.7
  }, "Reported strongest Russian rubles since 2015"))), /*#__PURE__*/React.createElement("text", {
    id: "despite sanctions in June.",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 690.602,
    y: 894.7
  }, "despite sanctions in June."))))), /*#__PURE__*/React.createElement("g", {
    id: "stones_copy_4"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M1450.1 634C1456.56 634 1461.8 628.583 1461.8 621.9C1461.8 615.217 1456.56 609.8 1450.1 609.8C1443.64 609.8 1438.4 615.217 1438.4 621.9C1438.4 628.583 1443.64 634 1450.1 634Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M1560.1 567C1566.56 567 1571.8 561.583 1571.8 554.9C1571.8 548.217 1566.56 542.8 1560.1 542.8C1553.64 542.8 1548.4 548.217 1548.4 554.9C1548.4 561.583 1553.64 567 1560.1 567Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M1738.8 593.5C1745.26 593.5 1750.5 588.083 1750.5 581.4C1750.5 574.717 1745.26 569.3 1738.8 569.3C1732.34 569.3 1727.1 574.717 1727.1 581.4C1727.1 588.083 1732.34 593.5 1738.8 593.5Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M1450 712.5V622.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lorem_ipsum_dolor_sit_amet_x2C__consectetuer_adipiscing_elit_15"
  }, /*#__PURE__*/React.createElement("text", {
    id: "The rise Wagner group has significantly increased internal",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1192.6,
    y: 735.7
  }, "The rise Wagner group has significantly increased internal"))), /*#__PURE__*/React.createElement("text", {
    id: "political instability in Russia and weakened ruble.",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 1192.6,
    y: 760.7
  }, "political instability in Russia and weakened ruble.")))))), /*#__PURE__*/React.createElement("text", {
    id: "Dynamics of the Russian Ruble Exchange Rate",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 38,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 642.602,
    y: 152.118
  }, "Dynamics of the Russian Ruble Exchange Rate"))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 108.691,
    y: 319.25,
    width: 1681.12,
    height: 422.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.02a6000c0f5585b8ce325b49bdd2a104.svg";
export { ForwardRef as ReactComponent };